import { default as employeeMigrationInfoTypes } from "./types";

const {
  FETCH_EMPLOYEE_MIGRATION_INFO_REQUEST,
  FETCH_EMPLOYEE_MIGRATION_INFO_SUCCESS,
  FETCH_EMPLOYEE_MIGRATION_INFO_FAILURE,
} = employeeMigrationInfoTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEE_MIGRATION_INFO_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_EMPLOYEE_MIGRATION_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_EMPLOYEE_MIGRATION_INFO_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
